/**
 * @generated SignedSource<<37103d3f877cec50ef8ee07e7f774bd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobShare_Job$data = {
  readonly firm: {
    readonly slug: string | null | undefined;
  } | null | undefined;
  readonly referralFromSelf: {
    readonly token: string | null | undefined;
  } | null | undefined;
  readonly slug: string | null | undefined;
  readonly " $fragmentType": "JobShare_Job";
};
export type JobShare_Job$key = {
  readonly " $data"?: JobShare_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobShare_Job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobShare_Job",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Firm",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Referral",
      "kind": "LinkedField",
      "name": "referralFromSelf",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "token",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};
})();

(node as any).hash = "699e55eb463821ded27c9dcbce4a7f2d";

export default node;
